import React, { Component } from 'react';
import TracesStore from 'Stores/tracesStore';
import SettingsBlock from "Components/Common/settingsBlock";
import { observer } from "mobx-react";
import Switcher from "Components/Common/switcher";
import 'Styles/traces.scss';
import AppStore from 'Stores/AppStore';

class Traces extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Управление трассировкой');

        TracesStore.LoadTracesKeys();
    }

    render() {
        return (
            <div className='smr-traces-settings'>
                <SettingsBlock title='Трассировка'>
                    <div className='keys-container overflowing-element'>
                        {Object.keys(TracesStore.tracesKeys).map(key => (
                            <div className='smr-traces-settings-trace-line'
                                key={`trace_line_${key}`}>
                                <div className='trace-key-title'>{key}</div>
                                <Switcher currentState={TracesStore.tracesKeys[key]}
                                    changed={(val) => {
                                        TracesStore.tracesKeys[key] = val;
                                        TracesStore.SetTraceKey(key, val);
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </SettingsBlock>
                <div className='buttons-container'>
                    <button className='traces-big-button'
                        onClick={() => TracesStore.PrintTraces()}>
                        Выгрузить файл с трассой
                    </button>
                    <button className={'green-button traces-small-button' + (TracesStore.tracingInProcess ? ' disabled' : '')}
                        onClick={() => TracesStore.SwitchTracingOn()}>
                        Трассировать
                    </button>
                    <button className={'red-button traces-small-button' + (TracesStore.tracingInProcess ? '' : ' disabled')}
                        onClick={() => TracesStore.SwitchTracingOff()}>
                        Закончить
                    </button>
                </div>
            </div>
        )
    }
}

export default observer(Traces);